module.exports = __webpack_public_path__ + "static/media/FormatoSimplificado_1001338.7e5b49cb.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/media/ift/InternetSatF/FormatoSimplificado_1001338.pdf
// module id = 345
// module chunks = 0